// extracted by mini-css-extract-plugin
export default {"card":"card_card__MI53I","cover":"card_cover__4VA88","info":"card_info__I6U9C","title":"card_title__0JYTl","author":"card_author__oc3lD"};